// services/admin.time-preference.service.js
import ApiService from './api.service';

const AdminTimePreferenceService = {
    getUserPreference: (userId) => 
        ApiService.fetch(`admin/users/${userId}/time-preferences`),
    
    updateUserPreference: (userId, data) => 
        ApiService.fetch(`admin/users/${userId}/time-preferences`, {
            method: 'PUT',
            body: JSON.stringify(data)
        })
};


export default AdminTimePreferenceService;
